module.exports = __webpack_public_path__ + "img/csv.5e6a87d7.svg";